export * from './addon.service';
import { AddonService } from './addon.service';
export * from './admin.service';
import { AdminService } from './admin.service';
export * from './banner.service';
import { BannerService } from './banner.service';
export * from './cart.service';
import { CartService } from './cart.service';
export * from './city.service';
import { CityService } from './city.service';
export * from './delivery.service';
import { DeliveryService } from './delivery.service';
export * from './deliveryPaying.service';
import { DeliveryPayingService } from './deliveryPaying.service';
export * from './deliveryReceipt.service';
import { DeliveryReceiptService } from './deliveryReceipt.service';
export * from './deliveryTurn.service';
import { DeliveryTurnService } from './deliveryTurn.service';
export * from './home.service';
import { HomeService } from './home.service';
export * from './item.service';
import { ItemService } from './item.service';
export * from './itemCategory.service';
import { ItemCategoryService } from './itemCategory.service';
export * from './notification.service';
import { NotificationService } from './notification.service';
export * from './offer.service';
import { OfferService } from './offer.service';
export * from './optional.service';
import { OptionalService } from './optional.service';
export * from './order.service';
import { OrderService } from './order.service';
export * from './orderItem.service';
import { OrderItemService } from './orderItem.service';
export * from './page.service';
import { PageService } from './page.service';
export * from './pricePerKmDelivery.service';
import { PricePerKmDeliveryService } from './pricePerKmDelivery.service';
export * from './rate.service';
import { RateService } from './rate.service';
export * from './slider.service';
import { SliderService } from './slider.service';
export * from './store.service';
import { StoreService } from './store.service';
export * from './storePaying.service';
import { StorePayingService } from './storePaying.service';
export * from './storeType.service';
import { StoreTypeService } from './storeType.service';
export * from './user.service';
import { UserService } from './user.service';
export * from './userAddress.service';
import { UserAddressService } from './userAddress.service';
export const APIS = [AddonService, AdminService, BannerService, CartService, CityService, DeliveryService, DeliveryPayingService, DeliveryReceiptService, DeliveryTurnService, HomeService, ItemService, ItemCategoryService, NotificationService, OfferService, OptionalService, OrderService, OrderItemService, PageService, PricePerKmDeliveryService, RateService, SliderService, StoreService, StorePayingService, StoreTypeService, UserService, UserAddressService];
